import type { Link, ValueOf } from '@evc/web-components';

export const PRODUCT_KINDS = {
  SOFTWARE: 'software',
  INSTRUMENTS: 'instruments',
  ACCESSORIES: 'accessories',
} as const;

export type ProductKind = (typeof PRODUCT_KINDS)[keyof typeof PRODUCT_KINDS];

export type ProductSupportCategory = {
  slug: ProductKind;
  title: string;
};

export type ProductSupportGroup = {
  slug: string;
  title: string;
};

export type ProductSupportImage = {
  src: string;
  alt: string;
};

export type ProductSupportListItem = {
  slug: string;
  title: string;
  category: ProductSupportCategory;
  group: ProductSupportGroup;
  image?: ProductSupportImage;
  isFeatured?: boolean;
};

export const DOWNLOAD_ACTION_TYPES = {
  GOOGLE: 'googlePlay',
  APPLE: 'appStore',
  DOWNLOAD: 'download',
} as const;

export type DownloadActionType = ValueOf<typeof DOWNLOAD_ACTION_TYPES>;

export type DownloadAction = {
  kind: DownloadActionType;
  href: string;
  label?: string;
};

export type ProductSupportSoftwareVersion = {
  version: string;
  date?: string;
  releaseNotes?: Link;
  action?: DownloadAction;
  defaultExpanded?: boolean;
};

export type ProductSupportSoftwareDownload = {
  id: string;
  title: string;
  subtitle: string;
  items: ProductSupportSoftwareVersion[];
};

export type ProductSupportDocumentationItem = {
  title: string;
  languagesText: string | string[];
  url: string;
};

export type ProductSupportDetail = {
  slug: string;
  title: string;
  category: ProductSupportCategory;
  softwareDownloads: ProductSupportSoftwareDownload[];
  documentation: ProductSupportDocumentationItem[];
};

export type ProductSupportItem = ProductSupportListItem &
  Partial<ProductSupportDetail> & {
    loaded?: string;
  };
